<div class="container">
  <!-- CI-Kachel: Material aus `al-glass al-glass--tile` (styles.scss
       „Kacheln"), Inhalt in `.al-glass__body` über dem Lichtsaum. -->
  <div
    class="card al-glass al-glass--tile"
    [attr.aria-current]="isSelected ? 'true' : null"
  >
    <div class="card-body al-glass__body">
    <div class="box al-divide-after">
      <div class="name">{{ product.name | translate }}</div>

      <div class="price">
        <div class="currency">€</div>
        <div class="euro" *ngIf="product.price > -1">
          {{ getEuroPrice() }}
        </div>
        <div class="cent" *ngIf="product.price !== 0 && product.price !== -1">
          {{ decimalSeparator }}{{ getCentPrice() }}
        </div>
        <div class="euro small" *ngIf="product.price === -1">
          {{ "components.productCard.priceIndividually" | translate }}
        </div>
      </div>

      <div class="price-interval" *ngIf="product.price > 0">
        {{
          (effectiveInterval === "year"
            ? "components.productCard.perYear"
            : "components.productCard.perMonth"
          ) | translate
        }}
      </div>

      <div class="vat-note" *ngIf="showsVatNote">
        {{ "components.productCard.plusVat" | translate }}
      </div>

      @if (product.hasTrial && canUseTrial) {
      <button
        nbButton
        fullWidth=""
        status="info"
        class="button"
        (click)="startTrial()"
      >
        {{ "components.productCard.startTestVersionButton" | translate }}
      </button>
      } @else if (isSelected) {
      <!-- Aktueller Plan: kein Knopf, sondern die eingedrückte CI-Fläche
           (CI-REGELN.md §Eingedrückte Auswahl). Vorher ein weißer Knopf mit
           blauem Rahmen per !important und `pointer-events: none`. -->
      <span class="current-plan al-pressed">
        <span class="al-icon al-icon--check" aria-hidden="true"></span>
        {{ "buttons.active" | translate }}
      </span>
      } @else {
      <button
        nbButton
        fullWidth=""
        status="primary"
        class="button"
        (click)="selectProduct()"
      >
        @if (isIntervalSwitch) {
        {{ switchLabelKey | translate }}
        } @else{ @if (product.price === -1) {
        {{ "buttons.request" | translate }}
        } @else{
        {{ "buttons.select" | translate }}
        } }
      </button>
      }
    </div>

    <div class="extras">
      <p>
        {{ "components.productCard.planFeatures" | translate }}
      </p>
      <!-- CI-Liste: Gravur zwischen den Zeilen, flaches einfarbiges Häkchen.
           Eine Leistung ist ein Text oder `{ text, tooltip }` — die
           Erklärung wie auf der Preisseite hinter dem Info-Symbol. -->
      <ul class="al-list features">
        <li *ngFor="let item of product.items | translate">
          <div class="feature">
            <span class="al-icon al-icon--check" aria-hidden="true"></span>
            <span>
              {{ item.text ?? item }}
              @if (item.tooltip) {
              <nb-icon
                icon="info-outline"
                class="feature__info"
                tabindex="0"
                [attr.aria-label]="item.tooltip"
                [nbTooltip]="item.tooltip"
                nbTooltipPlacement="top"
              ></nb-icon>
              }
            </span>
          </div>
        </li>
      </ul>
    </div>
    </div>
  </div>
</div>
